module.exports = __webpack_public_path__ + "static/media/eduImgWhite.c0e4eca1.svg";